import { isEmpty } from 'lodash'
import { IData } from '../fetchPriceConfiguration'
import { IKid, IKidTax, IPriceConfiguration } from '../index'
import { mapItemToPrice } from '../../../utils/Money'

export default function(response: IData) {
  return response.items.map(
    (item): IPriceConfiguration => ({
      currency: item.currency,
      default: Boolean(Number(item.default)),
      food: Boolean(Number(item.food)),
      foodBb: mapItemToPrice(item.food_bb),
      foodBbIncluded: Boolean(Number(item.food_bb_included)),
      foodFb: mapItemToPrice(item.food_fb),
      foodFbIncluded: Boolean(Number(item.food_fb_included)),
      foodHb: mapItemToPrice(item.food_hb),
      foodHbIncluded: Boolean(Number(item.food_hb_included)),
      idObject: Number(item.id_object),
      kids_tax: mapItemToKidsTax(item.kids_taxes),
      kids: mapItemToKids(item.kids),
      localTaxDays: Number(item.localtax_days),
      kidsPrice: Boolean(Number(item.kids_price)),
      localTax: Boolean(Number(item.localtax)),
      localTaxAdults: mapItemToPrice(item.localtax_adults),
      localTaxIncluded: Boolean(Number(item.localtax_included)),
      localTaxKids: mapItemToPrice(item.localtax_kids),
      pricePerPerson: Boolean(Number(item.price_per_person)),
      restrictionCloseAtArrival: Boolean(
        Number(item.restriction_close_at_arrival),
      ),
      restrictionCloseAtDeparture: Boolean(
        Number(item.restriction_close_at_departure),
      ),
      restrictionExactStay: Boolean(Number(item.restriction_exact_stay)),
      restrictionMaxBeforeArrival: Boolean(
        Number(item.restriction_max_before_arrival),
      ),
      restrictionMaxStay: Boolean(Number(item.restriction_max_stay)),
      restrictionMaxStayThru: Boolean(Number(item.restriction_max_stay_thru)),
      restrictionMinBeforeArrival: Boolean(
        Number(item.restriction_min_before_arrival),
      ),
      restrictionMinStay: Boolean(Number(item.restriction_min_stay)),
      restrictionMinThru:  Boolean(Number(item.restriction_min_stay_thru)),
      restrictions: Boolean(Number(item.restrictions)),
      stay: !!(Number(item.long_stay_price) || Number(item.short_stay_price)),
      stayLongFrom: Number(item.long_stay_price),
      stayShortTo: Number(item.short_stay_price),
      weekendPrice: Boolean(Number(item.weekend_price)),
      integrations: item.integrations,
      displayed: Boolean(Number(item.displayed)),
      switch_status: item.switch_status
    }),
  )
}

function mapItemToKids(item): IKid[] {
  return isEmpty(item)
    ? [{}]
    : (Object.values(item).map((k: any) => ({
        ageFrom: Number(k.age_from),
        ageTo: Number(k.age_to),
        foodDiscount: k.food_discount,
        id: k.id,
      })) as any)
}
function mapItemToKidsTax(item): IKidTax[] {
  return isEmpty(item)
    ? [{}]
    : (Object.values(item).map((k: any) => ({
        ageFrom: Number(k.age_from),
        ageTo: Number(k.age_to),
        taxes: k.taxes === 0 ? '0.00' : k.taxes,
        id: k.id,
      })) as any)
}
